import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { Headers, RequestOptions } from '@angular/http';
import { AppConfig } from '../app.config';
import { userInfo } from 'os';
import {environment} from '../../environments/environment';
@Injectable()
export class Login {

  // private TokenUrl = 'http://app.ccpdashboard.com:3400/token';
  //private TokenUrl = AppConfig.settings.apiServer.tokenUrl;
  public baseurl: string = environment.base_url;
  constructor(private http: Http) { }

  SignIn(email, password, role) {
   let headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded','LoginRole':role });
    let options = new RequestOptions({ headers: headers });
    return this.http.post(this.baseurl+"token", "userName=" + encodeURIComponent(email) +
      "&password=" + encodeURIComponent(password) +
      "&grant_type=password", options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  isUserRegistered(accessToken) {
    var url = this.baseurl+'token/Account/UserInfo';
    var bearer = 'Bearer ' + accessToken;
    let headers = new Headers({ 'Content-Type': 'application/json','Authorization': bearer });
    let options = new RequestOptions({ headers: headers });
    return this.http.get(url, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  signUpExternalUser(accessToken): Observable<any> {
    var url = this.baseurl+'token/Account/RegisterExternal';
    var bearer = 'Bearer ' + accessToken;
    let body = JSON.stringify("");
    let headers = new Headers({ 'Content-Type': 'application/json' ,'Authorization': bearer});
    let options = new RequestOptions({ headers: headers, method: "post" });
    return this.http.post(url, body, options)
        .map(this.extractData)
        .catch(this.handleError);
}

  GetUserDetail(email, token: any): Observable<any> {
    var url = this.baseurl + "api/User/SignIn?Email=" + email;
    var bearer = 'Bearer ' + token.access_token;
    let headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded', 'Authorization': bearer });
    let options = new RequestOptions({ headers: headers });
    return this.http.get(url, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  private extractData(res: Response) {
    let body = res.json();
    return body;
  }

  private handleError(error: Response | any) {
    // In a real world app, you might use a remote logging infrastructure
    let errMsg: string;
    if (error instanceof Response) {
      const body = error.json() || '';
      const err = body.error || JSON.stringify(body);
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    console.error(errMsg);
    return Observable.throw(errMsg);
  }



}



// WEBPACK FOOTER //
// /Users/mowebdevice/Desktop/Web Project/angular-scrubup/src/app/Services/login-service.ts